export default __webpack_public_path__ + "static/media/spark_25.6e02a2c8.png";